import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import {
    FlowOfFunds,
    RequestConsiderationRowRemovalRequest,
} from '../../../../models/FlowOfFunds/flow-of-funds.model';

const ConflictStatusCode = 409;

export interface RequestConsiderationRowRemovalParams extends RequestConsiderationRowRemovalRequest {
    engagementId: number;
    section: number;
    rowKey: number;
}

export interface RequestConsiderationRowRemovalRejection {
    isConflict: boolean;
}

export const RequestConsiderationRowRemoval = createAsyncThunk(
    'flowOfFunds/requestConsiderationRowRemoval',
    async (params: RequestConsiderationRowRemovalParams, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.post(
                `/api/PurchasePriceConsideration/${params.engagementId}/Rows/${params.section}/${params.rowKey}/RemovalRequest`,
                {
                    version: params.version,
                }
            );

            if (response.status === ConflictStatusCode) {
                return dispatch.rejectWithValue({
                    isConflict: true,
                } as RequestConsiderationRowRemovalRejection);
            }

            if (response.status !== 200) {
                throw new Error('Failed to request row removal');
            }

            return response.data as FlowOfFunds;
        } catch (error) {
            createNotification('Could not request row removal.', 'error');
            return dispatch.rejectWithValue({
                isConflict: false,
            } as RequestConsiderationRowRemovalRejection);
        }
    }
);
